import { baseApi } from '@klp/core/api';

import { kontraktApiRoutes } from './api';
import { ByggKontrakt } from './classes';
import type {
    ByggKontraktRequest,
    ByggKontraktResponse,
    IByggKontrakt,
} from './classes';

export const byggKontraktApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getByggKontrakt: builder.query<
            ByggKontraktResponse,
            ByggKontraktRequest
        >({
            query: (requestParams) => {
                const { byggNummer, kundeNummer } = requestParams;
                const url = kundeNummer
                    ? kontraktApiRoutes.listKundeBygg(kundeNummer, byggNummer)
                    : kontraktApiRoutes.listBygg(byggNummer);
                return { url };
            },
            transformResponse: (
                response: IByggKontrakt,
                _meta,
                arg,
            ): ByggKontraktResponse => {
                const { filterKontraktDetaljerByArealIkkeMedregnet } = arg;
                let byggKontrakt = ByggKontrakt.parseObject(response);

                if (
                    filterKontraktDetaljerByArealIkkeMedregnet &&
                    byggKontrakt.kontraktDetaljer
                ) {
                    const filteredDetaljer =
                        byggKontrakt.kontraktDetaljer.filter(
                            (kontraktDetalj) =>
                                kontraktDetalj.arealIkkeMedregnet !== true,
                        );
                    byggKontrakt = ByggKontrakt.parseObject({
                        ...response,
                        kontraktDetaljer: filteredDetaljer,
                    });
                }

                return {
                    byggKontrakt,
                    filterKontraktDetaljerByArealIkkeMedregnet,
                };
            },
            providesTags: (_result, _error, arg) => [
                { type: 'ByggKontrakt', id: arg.byggNummer },
            ],
        }),
    }),
});

export const { useGetByggKontraktQuery, useLazyGetByggKontraktQuery } =
    byggKontraktApi;
